// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UEr0pZFQ7oSujLQVTeLI{flex-direction:column;display:flex}.OeJCAxzW3cAwzSkWTO8l{justify-content:flex-end;gap:8px;padding-top:32px;padding-bottom:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `UEr0pZFQ7oSujLQVTeLI`,
	"actions": `OeJCAxzW3cAwzSkWTO8l`
};
export default ___CSS_LOADER_EXPORT___;
